import './loadJquerySticky';

/**
 * @class StickyElem
 */
class StickyElem {

    /**
     * Stickys up to the footer
     *
     * @param {jQuery} $element
     */
    static add($element) {
        var bottomSpacing = document.querySelector('footer').offsetHeight;
        $element.sticky && $element.sticky({bottomSpacing: bottomSpacing});
    }
}

export {StickyElem};
export default StickyElem;
